import { ListViewModelImpl } from '../../../../../toolkit/horizontallist/listviewmodel';
import { CategoryDto } from '../../../../../../core/dto/categories/categorydto';
import * as React from 'react';
import { BaseContext } from '../../../../../../utils/basecontext';
import { MultiselectCategoryCardComponent } from './categorycard/multiselectcategorycardcomponent';

export class MultiselectCategoryListViewModelImpl extends ListViewModelImpl<CategoryDto>
{
    private selectedCategoriesList: string[];

    private isEditable: boolean;

    constructor(context: BaseContext)
    {
        super(context);

        this.selectedCategoriesList = [];
        this.onCategorySelected = this.onCategorySelected.bind(this);
    }

    setIsEdiatble(isEditable:  boolean)
    {
        this.isEditable = isEditable;
    }

    setExistingSelectedCategoriesList(categoriesList: string[]): void
    {
        // this.selectedCategoriesList = categoriesList;

        this.selectedCategoriesList.length = 0;

        categoriesList.forEach((id: string) =>
        {
            this.selectedCategoriesList.push(id);
        });

        console.log("----selected list: " + JSON.stringify(this.selectedCategoriesList));
    }

    getView(t: CategoryDto, position: number): boolean | JSX.Element 
    {
        return <MultiselectCategoryCardComponent isSelected={this.isCategoriesSelected(t.getId())} isEditable={this.isEditable} key={position} onSelected={this.onCategorySelected} context={this.getContext()} categoryDto={t}  position={position}/>;
    }

    getSelectedCategoriesList()
    {
        return this.selectedCategoriesList;
    }

    protected onCategorySelected(isSelected: boolean, categoryDto: CategoryDto): void
    {
        if(isSelected)
        {
            this.selectedCategoriesList.push(categoryDto.getId());
        }
        else
        {
           this.selectedCategoriesList = this.selectedCategoriesList.filter((categoryId: string) =>
            {
                return categoryDto.getId() !== categoryId;
            });
        }
    }

    getIsEditable(): boolean
    {
        return this.isEditable;
    }
    protected isCategoriesSelected(id: string): boolean
    {
        let isExist = this.selectedCategoriesList.findIndex((categoryId: string) =>
        {
            return id === categoryId;
        });

        return isExist !== -1 ? true : false;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/categorylist/viewmodel/multiselectcategorylistviewmodel.tsx